import React from 'react';

import {OETarget} from '../../../react-oe/oe-target';
import OEIconCodes from '../../../lib/oe-icon-codes';
import OEProtoCapBar from '../oe-proto-cap-bar';
import {OEScienceTargetType, OEScienceTargets, OEScienceFeatureAccess, OEScienceStartSelectionData} from './oe-science-model';

export default class OEScienceCapBar extends React.PureComponent {

    constructor(props) {
        super(props);

        this.targetTypeMap = {
            [OEScienceTargetType.anatomy]:      {icon: OEIconCodes.science.anatomyTarget, noTargetTypeBarEntry: true, titleId: 'cap_bar_target_title_anatomy'},
            [OETarget.effigosExplorerHelp]:     {target: OETarget.effigosExplorerHelp, icon: OEIconCodes.help, noTargetTypeBarEntry: true, titleId: 'target_menu_effigosExplorerHelp'}
        };
    }

    render()    {
        let targetTypes = OEScienceStartSelectionData.chooseModules().map(module => module.id);
        targetTypes.push(OETarget.effigosExplorerHelp);

        return (
            <OEProtoCapBar
                {...this.props}
                targetTypes={targetTypes}
                targetTypeMap={this.targetTypeMap}
                versionTargets={OEScienceTargets}
                featureAccess={OEScienceFeatureAccess}
                startSelectionData={OEScienceStartSelectionData}
            />
        );
    }
}